/**
 * LinkedInQR — statična QR koda (vgrajen SVG), ki odpre LinkedIn profil.
 * Generirana ob izdelavi (paket `qrcode`), brez zunanjih klicev / runtime odvisnosti.
 * Vsebina: https://www.linkedin.com/in/andrejsersen
 * Vedno temni moduli na beli podlagi (zaradi skenljivosti tudi v temnem načinu).
 */
export function LinkedInQR({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29 29"
      shapeRendering="crispEdges"
      className={className}
      role="img"
      aria-label="QR koda — LinkedIn profil Andreja Seršena"
    >
      <path fill="#ffffff" d="M0 0h29v29H0z" />
      <path
        stroke="#000000"
        d="M0 0.5h7m4 0h1m2 0h1m1 0h5m1 0h7M0 1.5h1m5 0h1m2 0h1m2 0h2m1 0h3m2 0h1m1 0h1m5 0h1M0 2.5h1m1 0h3m1 0h1m1 0h5m2 0h2m2 0h1m2 0h1m1 0h3m1 0h1M0 3.5h1m1 0h3m1 0h1m1 0h2m1 0h5m1 0h1m4 0h1m1 0h3m1 0h1M0 4.5h1m1 0h3m1 0h1m1 0h2m4 0h1m1 0h5m1 0h1m1 0h3m1 0h1M0 5.5h1m5 0h1m1 0h6m1 0h2m5 0h1m5 0h1M0 6.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M8 7.5h2m1 0h2m1 0h1m4 0h2M0 8.5h1m1 0h5m2 0h1m1 0h9m2 0h5M0 9.5h1m1 0h1m1 0h2m2 0h3m5 0h4m1 0h4m3 0h1M0 10.5h1m5 0h1m7 0h2m1 0h1m4 0h1M4 11.5h2m5 0h2m1 0h1m4 0h3m1 0h1m1 0h1m1 0h1M1 12.5h8m2 0h4m2 0h1m1 0h1m5 0h2M0 13.5h1m1 0h1m2 0h1m2 0h1m1 0h2m1 0h1m2 0h7m1 0h1m3 0h1M2 14.5h3m1 0h1m3 0h2m1 0h4m1 0h1m1 0h4m1 0h2M1 15.5h1m2 0h1m3 0h2m2 0h1m2 0h2m6 0h2m2 0h1M1 16.5h1m3 0h2m2 0h3m3 0h1m1 0h1m1 0h1m3 0h1m1 0h2M0 17.5h1m1 0h1m2 0h1m1 0h1m2 0h1m2 0h1m2 0h9m1 0h1m1 0h1M0 18.5h1m3 0h3m1 0h1m2 0h1m1 0h3m1 0h1m4 0h2m2 0h1M0 19.5h1m1 0h3m3 0h1m3 0h2m4 0h1m1 0h5m2 0h1M0 20.5h1m2 0h1m2 0h1m2 0h4m1 0h5m1 0h5m1 0h3M8 21.5h3m1 0h1m3 0h3m1 0h1m3 0h5M0 22.5h7m2 0h1m1 0h2m2 0h1m1 0h1m1 0h2m1 0h1m1 0h3M0 23.5h1m5 0h1m1 0h1m1 0h1m1 0h1m1 0h3m2 0h2m3 0h1m2 0h1M0 24.5h1m1 0h3m1 0h1m1 0h1m2 0h1m3 0h1m1 0h1m2 0h5m1 0h3M0 25.5h1m1 0h3m1 0h1m1 0h1m1 0h3m1 0h1m1 0h1m1 0h2m3 0h1m1 0h4M0 26.5h1m1 0h3m1 0h1m1 0h2m2 0h1m2 0h1m2 0h2m1 0h7M0 27.5h1m5 0h1m2 0h4m3 0h1m3 0h4m1 0h1m1 0h1M0 28.5h7m1 0h2m3 0h1m3 0h1m1 0h1m2 0h5"
      />
    </svg>
  );
}
